import * as React from "react";
import { Price as Price$1 } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
const ariaLabelKeys = {
  full: void 0,
  new: "common.discountedPrice",
  old: "common.originalPrice"
};
const Price = ({
  "aria-label": ariaLabel,
  "data-t": dataT,
  hasFixedDecimals = false,
  isCentAmount = false,
  size,
  type = "full",
  value,
  ...rest
}) => {
  const { locale, getLabel, currency } = useIntl();
  const ariaLabelKey = ariaLabelKeys[type];
  const defaultAriaLabel = ariaLabelKey ? getLabel(ariaLabelKey) : void 0;
  const ariaLabelValue = ariaLabel || defaultAriaLabel;
  const formattedPrice = formatPrice({
    locale,
    value,
    currency,
    isCentAmount,
    fixedDecimals: hasFixedDecimals
  });
  return /* @__PURE__ */ React.createElement(Price$1, { "aria-label": ariaLabelValue, "data-t": dataT, type, size, ...rest }, formattedPrice);
};
export {
  Price
};
//# sourceMappingURL=Price.js.map
